<template>
  <div v-redirect-if-no-permission:LOCATIONS>
    <DataTable
      :url="api.ACTIONS.LANDMARKS"
      :fieldsHiddenMain="[
        'deleted_at',
        'updated_at',
        'radius',
        'type',
        'polygon',
        'landmark_type',
        'clusters',
        'ejection_radius',
        'level',
        'parent_id',
        'ejection_polygon',
        'place_id',
        'formatted_address',
        'is_favorite',
        'is_passenger_favorite',
        'city'
      ]"
      :titles="titles"
      :actionsExtraMain="actionsExtraMain"
      :formatter="formatter"
      :initialUrlSearchParams="addType"
      perPage="100"
      :title="$t('maps.landmarkList.landmarks')"
    />
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";

export default {
  name: "LandmarkList",
  title() {
    return this.$t("maps.landmarkList.title");
  },
  components: { DataTable },
  computed: {
    titles() {
      return {
        id: "#",
        created_at: this.$t("maps.landmarkList.dateCreated"),
        street_number: this.$t("maps.landmarkList.streetNumber"),
        street_name: this.$t("maps.landmarkList.streetName"),
      };
    },
    addType() {
      const par = new URLSearchParams();
      par.append("landmark_type", "NORMAL");
      return par;
    },
    actionsExtraMain() {
      return {
        edit: {
          action: (item) => `/landmarks/${item.id}`,
        },
        add: {
          link: `/landmarks/add`,
        },
      };
    },
    formatter() {
      return {
        created_at(value) {
          const date = new Date(value);
          const day = date.getDate().toString().padStart(2, "0");
          const month = (date.getMonth() + 1).toString().padStart(2, "0");
          const year = date.getFullYear();
          const hours = date.getHours().toString().padStart(2, "0");
          const minutes = date.getMinutes().toString().padStart(2, "0");
          return `${day}-${month}-${year} ${hours}:${minutes}`;
        },
        centroid(value) {
          if (value) return JSON.stringify(value.coordinates);
        },
      };
    },
  },
};
</script>

<style scoped></style>
